// assets/help-button.js
document.addEventListener('DOMContentLoaded', function() {
  // 获取元素
  const helpButton = document.getElementById('helpButton');
  const helpSidebar = document.getElementById('helpSidebar');
  const closeButton = document.getElementById('closeSidebar');
  const contactForm = document.getElementById('help-contact-form');
  const formResponse = document.getElementById('formResponse');
  
  // 打开侧边栏
  if (helpButton) {
    helpButton.addEventListener('click', () => {
      helpSidebar.classList.add('active');
    });
  }
  
  // 关闭侧边栏
  if (closeButton) {
    closeButton.addEventListener('click', () => {
      helpSidebar.classList.remove('active');
    });
  }
  
  // 点击外部关闭
  document.addEventListener('click', (e) => {
    if (
      helpSidebar.classList.contains('active') && 
      !helpSidebar.contains(e.target) && 
      e.target !== helpButton
    ) {
      helpSidebar.classList.remove('active');
    }
  });
  
  // 表单提交处理
  if (contactForm) {
    contactForm.addEventListener('submit', function(e) {
      e.preventDefault();
      const submitButton = document.getElementById('help-submit');
      const originalButtonText = submitButton.textContent;
      
      // 禁用按钮防止重复提交
      submitButton.disabled = true;
      submitButton.textContent = 'send in progress...';
      
      // 清除之前的消息
      formResponse.innerHTML = '';
      formResponse.className = '';
      
      // 创建FormData对象
      const formData = new FormData(contactForm);
      
      // 添加Shopify需要的额外字段
      formData.append('form_type', 'contact');
      
      // 发送AJAX请求
      fetch('/contact', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json'
        }
      })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          // 成功消息
          formResponse.innerHTML = '<p class="success-message">The message has been sent and we will reply as soon as possible！</p>';
          formResponse.className = 'success';
          
          // 清空表单
          contactForm.reset();
        } else {
          // 错误处理
          let errorHtml = '<div class="error-message"><p>Submission failed. Please check：</p><ul>';
          
          if (data.errors) {
            data.errors.forEach(error => {
              errorHtml += `<li>${error}</li>`;
            });
          } else {
            errorHtml += `<li>Unknown error. Please try again later</li>`;
          }
          
          errorHtml += '</ul></div>';
          formResponse.innerHTML = errorHtml;
          formResponse.className = 'error';
        }
      })
      .catch(error => {
        formResponse.innerHTML = `<div class="error-message">Network error. Please try again later：${error.message}</div>`;
        formResponse.className = 'error';
      })
      .finally(() => {
        // 恢复按钮状态
        submitButton.disabled = false;
        submitButton.textContent = originalButtonText;
        
        // 滚动到消息位置
        formResponse.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    });
  }

 const helpEmailLinks = document.querySelectorAll('.open-help');

  helpEmailLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      if (helpButton) helpButton.click();
    });
  });

});